function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4b37"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4b37"] = parcelRequire;
}
parcelRequire.register("SPspU", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0a4cf59d82689a20$export$6503ec6e8aabbaf; }, function (v) { return $0a4cf59d82689a20$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0a4cf59d82689a20$export$f7ad0328861e2f03; }, function (v) { return $0a4cf59d82689a20$export$f7ad0328861e2f03 = v; });
var $0a4cf59d82689a20$export$6503ec6e8aabbaf;
var $0a4cf59d82689a20$export$f7ad0328861e2f03;
"use strict";
var $0a4cf59d82689a20$var$mapping = {};
function $0a4cf59d82689a20$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0a4cf59d82689a20$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0a4cf59d82689a20$var$resolve(id) {
    var resolved = $0a4cf59d82689a20$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0a4cf59d82689a20$export$6503ec6e8aabbaf = $0a4cf59d82689a20$var$register;
$0a4cf59d82689a20$export$f7ad0328861e2f03 = $0a4cf59d82689a20$var$resolve;

});

var $65c729720f4e2076$exports = {};

(parcelRequire("SPspU")).register(JSON.parse('{"9EE7Q":"index.59e3a7e1.js","86Jwh":"github.3c19a08d.svg","lTAHh":"special_event.ff87a8ed.svg"}'));


//# sourceMappingURL=index.4fc71b1b.js.map
